import { birdieHeaderLogo } from '@/assets';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Determine if we should navigate to home or stay put
  const handleLogoClick = () => {
    // If we're in an active flow, don't navigate away
    if (location.pathname.includes('/one-off/') || location.pathname.includes('/subscription/')) {
      return; // Don't navigate during active flows
    }
    navigate('/');
  };

  const navigationItems = [
    { label: 'Home', href: 'https://birdiegifts.com/' },
    { label: 'Our Services', href: 'https://birdiegifts.com/services/' },
    { label: 'Contact the Birdies', href: 'https://birdiegifts.com/contact/' },
  ];

  return (
    <header className="w-full bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div
            className={`flex items-center ${
              location.pathname.includes('/one-off/') || location.pathname.includes('/subscription/')
                ? 'cursor-default'
                : 'cursor-pointer hover:opacity-80'
            }`}
            onClick={handleLogoClick}
          >
            <img src={birdieHeaderLogo} alt="Birdie Logo" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigationItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                target="_blank"
                className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
              >
                {item.label}
              </a>
            ))}
            <a href="https://www.instagram.com/birdiegiftservices/" target="_blank" className="text-gray-600 hover:text-gray-900 transition-colors">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.3335 16C3.3335 10.0293 3.3335 7.04265 5.18816 5.18798C7.04283 3.33331 10.0282 3.33331 16.0002 3.33331C21.9708 3.33331 24.9575 3.33331 26.8122 5.18798C28.6668 7.04265 28.6668 10.028 28.6668 16C28.6668 21.9706 28.6668 24.9573 26.8122 26.812C24.9575 28.6666 21.9722 28.6666 16.0002 28.6666C10.0295 28.6666 7.04283 28.6666 5.18816 26.812C3.3335 24.9573 3.3335 21.972 3.3335 16Z"
                  stroke="#644b69"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23.344 8.66663H23.3307M22 16C22 17.5913 21.3679 19.1174 20.2426 20.2426C19.1174 21.3678 17.5913 22 16 22C14.4087 22 12.8826 21.3678 11.7574 20.2426C10.6321 19.1174 10 17.5913 10 16C10 14.4087 10.6321 12.8825 11.7574 11.7573C12.8826 10.6321 14.4087 9.99996 16 9.99996C17.5913 9.99996 19.1174 10.6321 20.2426 11.7573C21.3679 12.8825 22 14.4087 22 16Z"
                  stroke="#644b69"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-100 py-4">
            <nav className="space-y-2">
              {navigationItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left px-2 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
